<template>
    <el-dialog
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        class="dialog-container"
        center
        width="800px">
        <div slot="title" class="title">

            宣传信息详情
        </div>
        <div class="form-content padding-lr" v-loading="loading">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="ruleForm" label-width="130px">
                <el-form-item label="机构名称" prop="org_id">
                    <el-select v-model="ruleForm.org_id" disabled
                               class="inp" filterable placeholder="请选择">
                        <el-option v-for="item in orgList" :key="item.id"
                                   :label="item.org_name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="信息标题"
                              prop="info">
                    <el-input v-model="ruleForm.title"
                              class="inp"
                              placeholder="请输入"  disabled></el-input>
                </el-form-item>
                <el-form-item label="信息内容"
                              prop="content">
                    <el-input v-model="ruleForm.content"
                              :autosize="{ minRows: 5, maxRows: 5 }"
                              class="inp"
                              placeholder="请输入"
                              resize="none"
                              type="textarea"  disabled></el-input>
                </el-form-item>
                <el-form-item ref="files" class="" label="附件"
                              prop="files">
                    <div class="flex justify-start align-center">
                        <a v-if="ruleForm.files"
                           :href="ruleForm.files"
                           class="look" target="_blank">下载附件</a>
                    </div>
                </el-form-item>
            </el-form>
            <div class="btn-box">
                <div class="btn cancel" @click="handleClose">关闭</div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import {getPromoteDetail, org_lst} from "@/api/admin";

export default {
    name: "showDetailDialog",
    data() {
        return {
            orgList:[],
            ruleForm: {
                org_id: '',
                title: '',
                content: '',
                files: '',
            },
            rules: {

            },
            loading:false
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        id: {
            type: [String, Number],
            default: ''
        },
    },
    components: {},
    created() {

    },
    methods: {
        async init() {
            this.loading = true
            let _data = await org_lst(
                '',
                '',
                '',
                '',
                '',
                1,
                10000
            )
            this.orgList = _data.data.data
            _data = await getPromoteDetail(this.id)
            this.ruleForm = _data.data
            this.loading = false
        },
        handleClose() {
            this.$emit('handleClose', false)
        },
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible) {
                if (this.id) {
                    this.init()
                }
            }
        }
    },
    filters: {}
}
</script>

<style lang="scss" scoped>
.title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
}

.form-content {
    width: 100%;

    .title-flex {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 20px;

        b {
            font-size: 18px;
            color: #000000;
            font-weight: bold;
            margin-right: 10px;
        }
    }


    .width {
        width: 400px;
    }

    .btn-box {
        width: 100%;
        display: flex;
        justify-content: center;
        padding: 30px 0;

        .btn {
            width: 180px;
            height: 40px;
            background-image: linear-gradient(0deg,
                #2791ff 0%,
                #81b6ff 100%);
            border-radius: 20px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            letter-spacing: 1px;
            color: #ffffff;
            cursor: pointer;
            &.cancel{
                width: 180px;
                height: 40px;
                background: #f0f2f6;
                border-radius: 20px;
                border: solid 1px #c1c3c7;
                color: #9da0a7;
                margin-left: 20px;
            }
        }
    }

    .add {
        width: 24px;
        cursor: pointer;
    }


    .inp {
        width: 100%;
    }

    .tips {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        background-color: #fef0ef;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
        color: #f34336;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 16px;

        i {
            font-size: 20px;
            color: #f34336;
            margin-right: 4px;
        }

        &.width {
            width: 160px;
        }
    }

    .look {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        border: 1px solid #2791ff;
        color: #2791ff;
        line-height: 34px;
        text-align: center;
        font-size: 14px;
        margin-left: 10px;
        border-radius: 4px;

    }

    .mt15 {
        margin-top: 15px;
    }

    .btnUp {
        width: max-content;
        padding: 0 10px;
        height: 36px;
        margin-left: 10px;
        background-image: linear-gradient(90deg,
            #2791ff 0%,
            #81b6ff 100%);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #ffffff;

        i {
            font-size: 20px;
            color: #ffffff;
            margin-right: 5px;
            font-weight: 100;
        }
    }
}

.title-box {
    width: 100%;
    height: 60px;
    border-bottom: solid 2px #e3e7f0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .tit-left {
        display: flex;
        justify-content: flex-start;
        padding-top: 25px;

        img {

        }

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 5px;
        }
    }
}
</style>


